import type { HomeRangeKey } from '../../../hooks/useBillingRange';
import { SEGMENTED_TRACK_CLASSES, type SegmentedTrack } from './segmentedTrack';

// Segmented range picker shared by the billing overview, the per-practice
// insights pages and Home.

interface RangeControlProps<K extends HomeRangeKey> {
    active: K;
    onChange: (next: K) => void;
    options: readonly K[];
    track?: SegmentedTrack;
}

export function RangeControl<K extends HomeRangeKey>({
    active,
    onChange,
    options,
    track = 'gray'
}: RangeControlProps<K>) {
    return (
        <div
            role="group"
            aria-label="Date range"
            className={`flex items-center border rounded-lg p-1 ${SEGMENTED_TRACK_CLASSES[track]}`}
        >
            {options.map((option) => (
                <button
                    key={option}
                    type="button"
                    aria-pressed={option === active}
                    onClick={() => onChange(option)}
                    className={`px-3 h-8 rounded-md text-[13px] transition-colors ${
                        option === active
                            ? 'bg-gray-900 text-white font-semibold shadow-sm'
                            : 'font-medium text-gray-500 hover:text-gray-900 hover:bg-gray-200/60'
                    }`}
                >
                    {option}
                </button>
            ))}
        </div>
    );
}
